import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SupportChat from "../../components/dashboard/support-chat";

const SendAMessage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full w-full bg-[#F9F9F9] font-[glacial] relative pb-4">
      <div className="flex flex-col items-center pt-6 pb-4 border-b border-gray-200 bg-white">
        <button
          onClick={() => navigate("/support")}
          className="absolute top-6 left-6 p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <ChevronLeft size={24} className="text-gray-900" />
        </button>

        <div className="flex flex-col items-center gap-2">
          <div className="w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center">
            <span className="text-white text-2xl dcalligraphy">W</span>
          </div>
          <h1 className="text-base font-[optima] text-gray-900">Tola @ Weddn</h1>
        </div>
      </div>

      <SupportChat />
    </div>
  );
};

export default SendAMessage;
